import VDL from "@/modules/VDL"

function App() {
  return (
    <VDL />
  )
}

export default App
